import { render, staticRenderFns } from "./editionList.vue?vue&type=template&id=7fe6b5fe&"
import script from "./editionList.vue?vue&type=script&lang=js&"
export * from "./editionList.vue?vue&type=script&lang=js&"
import style0 from "./editionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe6b5fe')) {
      api.createRecord('7fe6b5fe', component.options)
    } else {
      api.reload('7fe6b5fe', component.options)
    }
    module.hot.accept("./editionList.vue?vue&type=template&id=7fe6b5fe&", function () {
      api.rerender('7fe6b5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edition/editionList.vue"
export default component.exports